import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeProvider } from '@emotion/react';
import { HelmetProvider } from 'react-helmet-async';
import Router from './routes/Router';
import { UserProvider } from './constants/context';
import { defaultTheme } from './constants/theme';
import { useScrollRestoration } from './hooks/useScrollRestoration';
import { GHLFormModalProvider } from './components/GHLFormModal/context';
import GHLFormModal from './components/GHLFormModal';
import { fetchPractitioners } from './redux/reducers/practitioners.reducer';
import './App.css';

function App() {
  const isScrollRestored = useScrollRestoration(120);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPractitioners());
  }, [dispatch]);

  return (
    <HelmetProvider>
      <ThemeProvider theme={defaultTheme}>
        <UserProvider>
          <GHLFormModalProvider>
            <div
              style={{
                opacity: isScrollRestored ? 1 : 0,
                transition: 'opacity 0.5s ease-in',
              }}
            >
              <Router />
            </div>
            <GHLFormModal />
          </GHLFormModalProvider>
        </UserProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
